import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IOrderBump } from 'interfaces/IProductData';
import { enProductType } from 'enums/enProductType';
import UserAddressForm from 'components/UserAddressForm';
import { WithStyles } from 'shared/decorators/withStyles';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { IProductData } from 'interfaces/IProductData';

interface IState extends IStateBase {
  cartAskAddress: boolean;
  isOneClick: boolean;
  cart: IProductData;
}

interface IProps {
  product: IOrderBump;
}

@WithStyles(() => ({
  component: {
    padding: '16px 16px 22px',
    '& .orderbumpaddress-description': {
      color: '#596375',
      fontSize: '0.777rem',
      padding: '0 0 16px'
    }
  }
}))
export default class OrderBumpAddressForm extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ cartAskAddress: null }, cartService.getConfig().map(config => config.askAddressBeforePayment));
    this.observeState({ isOneClick: false }, cartService.getConfig().map(config => config.isOneClick));
  }

  blockAddressAfterPayment = () => {
    paymentService.setBlockAddressAfterPayment(true);
  };

  render() {
    const { product } = this.props;

    if (product.type !== enProductType.PHYSICAL) {
      return null;
    }

    if (!this.state) {
      return null;
    }

    const { config } = this.state.cart;

    if (config.askAddressBeforePayment && !config.isOneClick) {
      return null;
    }

    if (config.askAddressBeforePayment && config.askAddressAfterPayment && !config.isOneClick) {
      return null;
    }

    this.blockAddressAfterPayment();

    return (
      <div className={this.props.classes.component}>
        <div className="orderbumpaddress-description">Para qual endereço deseja enviar o produto {product.title}?</div>
        <UserAddressForm />
      </div>
    );
  }
}
